import { FC, useEffect, useMemo, useState } from "react";
import { CoachCard, CoachRunDataSource } from "@quark/design";
import CoachPage from "../coach-page";
import { getChallengeRef } from "../../api";
import { Numerical } from "../../types";

interface CoachProps {
  challengeId: Numerical;
  name: string;
  description: string;
}

const Coach: FC<CoachProps> = ({ challengeId, name, description }) => {
  const [dataSource, setDataSource] = useState<CoachRunDataSource>(
    {} as CoachRunDataSource
  );

  const loaded = useMemo(() => {
    return !!dataSource.challenge_id;
  }, [dataSource]);

  const isPass = useMemo(() => {
    return dataSource.user_data?.is_pass;
  }, [dataSource]);

  const [showCoachRun, setShowCoachRun] = useState(false);

  const getCoachData = () => {
    getChallengeRef(challengeId).then((data) => {
      setDataSource(data);
    });
  };

  useEffect(() => {
    getCoachData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CoachCard
        finished={isPass}
        name={name}
        description={description}
        points={10}
        onButtonClick={() => {
          setShowCoachRun(true);
        }}
      />
      {loaded && (
        <CoachPage
          challengeId={challengeId}
          visible={showCoachRun}
          onClose={() => {
            setShowCoachRun(false);
          }}
          onSubmitReturn={() => getCoachData()}
        />
      )}
    </>
  );
};

export default Coach;
